<template>
    <div class="head">
        <div class="top-left">
          <img src="@/assets/image/head/logo.png" class="top-logo" :class="!isIndex ? 'cursor' : ''"
            @click="() => { !isIndex && gotoHome() }" />
          <img src="@/assets/image/head/back-main.png" class="back" @click="back"> 
        </div>
        <div class="top-right">
            <div class="menu" ref="menuRef">
                <el-tooltip placement="bottom" effect="dark" content="企业中心" :disabled="manual" :enterable="false"
                    popper-class="head-tooltip">
                    <img src="@/assets/image/head/menu.png" class="pointer" @click.stop="open = !open; manual = true"
                        @mouseenter="manual = false" @mouseleave="manual = true" />
                </el-tooltip>
                <div class="menu-content" v-show="open" ref="menuContentRef">
                    <div v-if="getRouterParamType !== 'home'" class="menu-item" @click.stop="handleClick(1)">
                        我的订单
                    </div>
                    <div v-if="getRouterParamType !== 'home'" class="menu-item" @click.stop="handleClick(4)">
                        我的优惠劵
                    </div>
                    <div v-if="getRouterParamType !== 'home'" class="menu-item" @click.stop="handleClick(2)">
                        项目管理
                    </div>
                    <div class="menu-item" @click.stop="handleClick(3)">
                        企业信息
                    </div>
                </div>
            </div>
            <div class="top-right-line"></div>
            <el-tooltip placement="bottom" effect="dark" :content="getPhone" :enterable="false"
                popper-class="head-tooltip">
                <div class="user">
                    <div class="top-right-avatar">
                        <img :src="userAvatar" class="avatar" />
                    </div>
                    <div class="top-right-name">{{ getCompanyName }}</div>
                </div>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeadPage',
    data() {
        return {
            open: false,
            companyName: null,
            manual: false,
        }
    },
    computed: {
        userAvatar() {
            return this.$store.state.userInfo.companyImage;
        },
        getCompanyName() {
            return this.companyName ? this.companyName : this.$store.state.userInfo.companyName;
        },
        isIndex() {
            return this.$route.path === '/' || this.$route.path === '/index';
        },
        getPhone() {
            return this.$store.state.userInfo.linkMobile;
        },
        //用于判断是从哪里跳转过来的
        getRouterParamType() {
            return this.$route.params.type || 'index'
        },
    },
    methods: {
        handleClick(type) {
            this.open = false
            this.$router.push({
                name: 'personalCenterChild',
                params: {
                    from: type,
                },
            })
        },
        gotoHome() {
            this.$router.push({
                path: '/',
            })
        },
        back() {
            this.$router.push({
                path: '/home',
            })
        },
        // 点击空白处关闭菜单
        handleDocumentClick(e) {
            // 检查菜单是否打开
            if (!this.open) return

            // 检查点击目标是否是菜单图标或菜单内容
            const menuEl = this.$refs.menuRef
            const menuContentEl = this.$refs.menuContentRef

            if (menuEl && !menuEl.contains(e.target) &&
                menuContentEl && !menuContentEl.contains(e.target)) {
                this.open = false
            }
        }
    },
    mounted() {
        // 监听文档点击事件
        document.addEventListener('click', this.handleDocumentClick)
    },
    beforeDestroy() {
        // 移除监听事件，避免内存泄漏
        document.removeEventListener('click', this.handleDocumentClick)
    },
    watch: {
        '$store.state.userInfo': {
            handler(newVal) {
                if (newVal.user === '1') {
                    this.companyName = newVal.companyName;
                }
            },
            deep: true
        }
    }

}
</script>

<style lang="scss" scoped>
.head {
    width: 100%;
    height: 6.4rem;
    background-image: url('@/assets/image/head/top-bg.png');
    background-size: 100% 100%;
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0px 0.3rem 1rem 0px rgba(17, 72, 153, 0.04);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;
    // margin-bottom: 10px;
}

.top-logo {
    width: 24.3rem;
    height: 4rem;
    margin-left: 4.4rem;
}

.top-left {
  display: flex;
  align-items: center;
  cursor: pointer;
  .back {
    margin-left: 2.4rem;
  }
}

.cursor {
    cursor: pointer;
}

.top-right {
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    align-items: center;
}

.top-icon {
    margin-right: 1.2rem;
}

.pointer {
    cursor: pointer;
}

.menu {
    position: relative;

    .menu-content {
        width: 17rem;
        position: absolute;
        top: 4.5rem;
        right: 50%;
        transform: translateX(50%);
        background: #FFFFFF;
        box-shadow: 0px 0.4rem 1.2rem 0px rgba(0, 0, 0, 0.15);
        border-radius: 0.4rem;
        display: flex;
        display: -webkit-box;
        display: -webkit-flex;
        flex-direction: column;
        align-items: center;
        padding: 1rem;
        box-sizing: border-box;

        .menu-item {
            width: 15rem;
            height: 3.6rem;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 1.4rem;
            color: #384D6E;
            text-align: center;
            line-height: 3.6rem;
            border-radius: 0.4rem;
            text-align: center;
            cursor: pointer;

            &:hover {
                background: #F0F6FF;
                color: #1D78FF;
            }
        }
    }

    img:hover {
        box-shadow: 0px 0.3rem 1rem 0px rgba(17, 72, 153, 0.04);
    }
}


.top-right-line {
    width: 0.2rem;
    height: 2rem;
    background: #E4E7ED;
    margin: 0 2.2rem;
}

.user {
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    align-items: center;
}

.top-right-avatar {
    width: 3.6rem;
    height: 3.6rem;
    border: 0.1rem solid #DBE0E5;
    border-radius: 50%;
    overflow: hidden;

    img {
        width: 3.6rem;
        height: 3.6rem;
        object-fit: cover;
    }
}

.top-right-name {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 1.6rem;
    color: #303133;
    margin-right: 4.4rem;
    margin-left: 1.2rem;
}
</style>
